// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__44xqt","bigColWidth":"Table_bigColWidth__1MeYS","biggerColWidth":"Table_biggerColWidth__Rm6nB","row":"Table_row__2mU7e","col":"Table_col__4FZmK"};